exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "td,tr{border-bottom:1px solid #ddd;font-size:23px}", "", {"version":3,"sources":["C:/Users/imkeeper/Desktop/Paybox/ui/C9/src/components/modal/showcloseshift.vue"],"names":[],"mappings":"AACA,MACE,6BAA8B,AAC9B,cAAe,CAChB","file":"showcloseshift.vue","sourcesContent":["\ntr, td {\n  border-bottom: 1px solid #ddd;\n  font-size: 23px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0051d9ba","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modal/showcloseshift.vue
// module id = 218
// module chunks = 2